module.exports = __webpack_public_path__ + "img/en.736a748d.svg";